// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1Z0Kz","header":"ClearentDisclaimer_header__1OQp5","inner":"ClearentDisclaimer_inner__1xg78"};